
/**
 * Custom hook to manage chat history and extract conversation context
 * @param {Array} messages - Array of message objects with role and text
 * @returns {Object} Object containing getConversationContext function
 */
export function useChatHistory(messages) {
  /**
   * Extract the last N user-bot message pairs from the messages array
   * @param {number} count - Number of message pairs to extract (default: 5)
   * @returns {Array} Array of conversation context objects [{ user: "text", bot: "text" }, ...]
   */
  const getConversationContext = (count = 5) => {
    const conversationPairs = [];
    let lastUserMsg = null;

    // Iterate through messages to pair user and bot messages
    for (let i = 0; i < messages.length; i++) {
      const msg = messages[i];
      
      if (msg.role === "user") {
        lastUserMsg = msg.text;
      } else if (msg.role === "bot" && lastUserMsg) {
        // We have a user-bot pair
        conversationPairs.push({
          user: lastUserMsg,
          bot: msg.text
        });
        lastUserMsg = null;
      }
    }

    // Return the last N pairs
    return conversationPairs.slice(-count);
  };

  return { getConversationContext };
}
